//libs
import { useContext, useState, useRef, useMemo, useEffect } from 'react';
import {
    transitions,
    positions,
    Provider as AlertProvider,
} from 'react-alert';

//components
import Search from './components/search';
import CountriesList from './components/countries-list';
import CitiesListAlphabet from './components/cities-list-alphabet';
import CitiesList from './components/cities-list';
import Marketplaces from './components/marketplaces';
import PartnerTypes from './components/partner-types';
import FeatureFilter from './components/feature-filter';
import AlertTemplate from './components/alert-template';
import { StoresContext } from '../../../App';
import MapSection from './components/map-section';

//styles
import './style.scss';

const options = {
    position: positions.TOP_CENTER,
    //timeout: 5000,
    offset: '50px',
    transition: transitions.FADE,
};

const COUNTRIES_LIST_TO_USE_ALPHABET = [
    'Россия',
    'Казахстан',
]

export default function IekRedisign() {
    const selectedCountryRef = useRef<HTMLDivElement | null>(null);
    const [selectedCountry, setSelectedCountry] = useState('');
    const {
        locationFilters,
        allStores,
        setLocationFilters,
        search,
    } = useContext(StoresContext);

    const setCountry = (country: string) => {
        setLocationFilters((values) => ({ country, region: '', city: '' }));
        setSelectedCountry(country);
    };

    const fullStoresCounters = useMemo(() => {
        const counters = new Map<string, number>()

        for (const s of allStores) {
            if (s.country) {
                let countryCounter = counters.get(s.country);

                if(countryCounter === undefined) {
                    countryCounter = 0;
                }

                countryCounter++;
                counters.set(s.country, countryCounter);
            }
        }

        return counters;
    }, [allStores]);

    useEffect(() => {
        if(selectedCountryRef && selectedCountry) {
            selectedCountryRef.current?.scrollIntoView({ behavior: 'smooth'});
        }
    }, [selectedCountry]);

    return (
        <AlertProvider template={AlertTemplate} {...options}>
            <section className="where-to-buy-generica" ref={selectedCountryRef}>
                <div className="page-title"> 
                    <div className="page-container">
                        <div className="page-title__content">
                            <h1>Где купить</h1>
                            {locationFilters.country ? (
                                <Search search={search}/>
                            ) : null}
                        </div>
                    </div>
                </div>
                <div className="page-container">
                    <div className="feature-filter">
                        {locationFilters.country ? (
                            <div className="feature-filter__row">
                                {COUNTRIES_LIST_TO_USE_ALPHABET.includes(locationFilters.country) ? (
                                    <CitiesListAlphabet fullStoresCounters={fullStoresCounters} />
                                ): (
                                    <CitiesList fullStoresCounters={fullStoresCounters} />
                                )}
                            </div>
                        ) : null}
                        <div className="feature-filter__row feature-filter__row--root">
                            <div className="feature-filter__column feature-filter__column--main">                                 
                                <CountriesList setCountry={setCountry} />
                            </div>
                            <div className="feature-filter__column feature-filter__column--optional"> 
                                <div className="feature-filter__row"> 
                                    <PartnerTypes />
                                </div>
                                <div className="feature-filter__row"> 
                                    <FeatureFilter />
                                </div>
                                <div className="feature-filter__row">
                                    <Marketplaces />                                       
                                </div>
                            </div>
                        </div>
                    </div>
                    {!locationFilters.country ? (
                        <MapSection />
                    ) : null}
                </div>
            </section>
        </AlertProvider>
    );
}
